import React, {useEffect, useState} from "react";
import './index.scss'
import {
  CabinetCasesIconSite,
  CabinetClientsIconCompare,
  CabinetClientsIconPresentation,
  CabinetClientsIconSF,
  CabinetClientsIconSite,
  CabinetCrmIconCalendar,
  CabinetCrmIconDeals, CabinetCrmIconEmployers,
  CabinetCrmIconFixation,
  CabinetCrmIconRecord,
  CabinetFavoritesIconComplexes,
  CabinetFavoritesIconCottageSettment,
  CabinetFavoritesIconObjects,
  CabinetMenuAutopanoramaIcon,
  CabinetMenuBonustIcon, CabinetMenuBronIcon,
  CabinetMenuContactIcon,
  CabinetMenuDriveIcon,
  CabinetMenuEventIcon, CabinetMenuFilesIcon,
  CabinetMenuIconClient,
  CabinetMenuIconCrm,
  CabinetMenuIconFavorites,
  CabinetMenuIconObjects, CabinetMenuMortgageIcon,
  CabinetMenuMotivationIcon,
  CabinetMenuSchoolIcon, CabinetMenuTradeInIcon,
  CabinetMenuVebinartIcon, CabinetMenuWelcomeIcon,
  CabinetObjectsIconFeed,
  CabinetObjectsIconHouse,
  MenuCloseIcon,
  MenuCRMIcon, MenuEventNewBigIcon,
  MenuExitIcon,
  MenuFixationIcon, MenuMortgageNewBigIcon,
  MenuMotivationIcon,
  MenuNavAdvIcon,
  MenuNavArrowIcon,
  MenuNavBackIcon,
  MenuNavCardIcon,
  MenuNavCaseIcon,
  MenuNavContactsIcon,
  MenuNavEventIcon,
  MenuNavFilesIcon,
  MenuNavLockIcon,
  MenuNavPeoplesIcon,
  MenuNavServicesIcon,
  MenuNavSiteIcon,
  MenuNavTableIcon,
  MenuNavTeachIcon,
  MenuNavWebRewIcon,
  MenuRecordIcon
} from "../../Public/markup/icons";
import {Link} from "react-router-dom";
import ClientMode from "../../Header/ClientMode";
import {logout} from "../../../actions/user";
import {connect} from "react-redux";
import {getUrl} from "../../../api";
import useMedia from "../../../hooks/useMedia";
import SearchById from "../../Header/SearchById";
import useApi from "../../../hooks/useApi";
import usePermission from "../../../hooks/usePermission";
import useClickPast from "../../../hooks/useClickPast";
import {BlockMenu} from "../../../pages/PersonalCabinet";
import {useModal} from "react-modal-hook";
import PanModal from "../PanModal";
import FixationsNew from "../../../pages/Fixations/fixationsNew";
import useCompanyRole from "../../../hooks/useCompanyRole";

const Menu = ({isOpen, setOpen, logout, user, servicesMenu, togglerNode}) => {

  const [services, setSercices] = useState(false)
  const showMotivation = usePermission("motivation");
  const showClients = usePermission("agent");
  const isLaptop = useMedia('isLaptop');

  const isCompanyManager = useCompanyRole(["full_access_company", "full_access_departament"]);
  const menuRef = useClickPast(null, ({ target }, { current }) => {
    if (current?.contains?.(target) || target?.closest?.('.menu')) return
    setOpen(false)
    setSercices(false)
  })

  useEffect(() => {
    isOpen ? window.BX?.SiteButton.hide() : window.BX?.SiteButton.show()
  }, [isOpen])

  const [addFixationtModal, closeFixationtModal] = useModal(
    () => (
      <PanModal title={'Фиксация клиента'} isBig closeModal={closeFixationtModal}>
        <FixationsNew closeFixationtModal={closeFixationtModal}/>
      </PanModal>
    ),
    [],
  );

  return (
    <div className={"menu" + (isOpen ? ' is-showing' : '')} ref={menuRef}>

      <div className="menu__title">
        <p className="menu__title-main">Главное меню</p>
        <div className="menu__close-menu" onClick={() => setOpen(false)}><MenuCloseIcon/></div>
      </div>
      {!!isLaptop &&
        <SearchById fullWidth align="left"/>
      }
      <div className="menu-profile">
        <div className="menu-profile__user">
          {(!!user?.avatar?.src || !!user?.logo?.src) &&
          <div className="menu-profile__user-logo">
            <img src={getUrl(user?.avatar?.src ?? user?.logo?.src)} alt=""/>
          </div>
          }

          <div className="menu-profile__user-contact">
            <p className="menu-profile__user-fio">{user?.lastName + ' ' + user?.name}</p>
            <Link className="menu-profile__user-toprofile" to="/personalcabinet/profile">Личный кабинет</Link>
          </div>
        </div>
        <div className="menu-profile__logout" onClick={() => logout()}>
          <MenuExitIcon/>
        </div>
      </div>

      <ClientMode new/>

      <div className="menu-cards-grid">
        <span onClick={addFixationtModal} className="menu-cards-grid__item">
          <div className="menu-cards-grid__item-info">
            <p className="menu-cards-grid__item-title">Фиксация</p>
            <p className="menu-cards-grid__item-text">Клиента</p>
          </div>
          <div className="menu-cards-grid__item-icon"><MenuFixationIcon/></div>
        </span>
        <Link to="/personalcabinet/viewing" className="menu-cards-grid__item">
          <div className="menu-cards-grid__item-info">
            <p className="menu-cards-grid__item-title">Просмотр</p>
            <p className="menu-cards-grid__item-text">Записаться</p>
          </div>
          <div className="menu-cards-grid__item-icon"><MenuRecordIcon/></div>
        </Link>
        <Link to="/events" className="menu-cards-grid__item">
          <div className="menu-cards-grid__item-info">
            <p className="menu-cards-grid__item-title">Мероприятия</p>
            <p className="menu-cards-grid__item-text">Календарь</p>
          </div>
          <div className="menu-cards-grid__item-icon"><MenuEventNewBigIcon/></div>
        </Link>
        <Link to="/mortgage" className="menu-cards-grid__item">
          <div className="menu-cards-grid__item-info">
            <p className="menu-cards-grid__item-title">Ипотека</p>
            <p className="menu-cards-grid__item-text">Калькулятор</p>
          </div>
          <div className="menu-cards-grid__item-icon"><MenuMortgageNewBigIcon/></div>
        </Link>
      </div>


      <div className="menu-newblock">
        <BlockMenu content={{
          title: 'Клиентские материалы',
          icon: <CabinetMenuIconClient />,
          items: [
            {
              to: "/crm/presentations",
              title: "Презентации",
              icon: <CabinetClientsIconPresentation />
            },
            {
              to: "/crm/filters",
              title: "Сохраненные фильтры",
              icon: <CabinetClientsIconSF />
            },
            {
              to: "/crm/compilations",
              title: "Подборки и сравнение",
              icon: <CabinetClientsIconCompare />
            },
            {
              to: "/constructor-admin",
              title: "Личный сайт",
              icon: <CabinetClientsIconSite />
            },
            {
              to: "/cases",
              title: "Кейсы",
              icon: <CabinetCasesIconSite />
            },
          ]
        }} />
        <BlockMenu content={{
          title: 'CRM',
          icon: <CabinetMenuIconCrm />,
          items: [
            {
              to: "/personalcabinet/clients",
              title: "Клиенты",
              icon: <MenuNavPeoplesIcon />
            },
            {
              to: "/personalcabinet/fixations",
              title: "Фиксации",
              icon: <CabinetCrmIconFixation />
            },
            {
              to: "/crm/viewing",
              title: "Записи на просмотр",
              icon: <CabinetCrmIconRecord />
            },
            {
              to: "/personalcabinet/deals",
              title: "Сделки",
              icon: <CabinetCrmIconDeals />
            },
            // {
            //   to: "",
            //   title: "Календарь",
            //   icon: <CabinetCrmIconCalendar />
            // },
          ]
        }} />
        <BlockMenu content={{
          title: 'Разделы',
          icon: <CabinetMenuIconObjects />,
          items: [
            ...(isCompanyManager ? [{
              to: "/personalcabinet/employees",
              title: "Сотрудники",
              icon: <CabinetCrmIconEmployers />
            }] : []),
            ...(showMotivation ? [{
              to: "/motivation",
              title: "Мотивация ",
              icon: <CabinetMenuMotivationIcon />
            }] : []),
            {
              to: "https://bonus.panpartner.ru/",
              title: "Бонусы",
              icon: <CabinetMenuBonustIcon />
            },
            {
              to: "/contacts",
              title: "Контакты",
              icon: <CabinetMenuContactIcon />
            },
            // {
            //   to: "/favorites",
            //   title: "Избранное",
            //   icon: <CabinetObjectsIconFeed />
            // },

            {
              to: "/files",
              title: "Файлы",
              icon: <CabinetMenuFilesIcon />
            },
            // {
            //   to: "/mortgage",
            //   title: "Ипотека",
            //   icon: <CabinetMenuMortgageIcon />
            // },
            {
              to: "/adv-booking",
              title: "Расширенное бронирование",
              icon: <CabinetMenuBronIcon />
            },
            {
              to: "/trade-in",
              title: "Trade-in",
              icon: <CabinetMenuTradeInIcon />
            },
            {
              to: "/personal/meetings",
              title: "Welcome-столы для встреч",
              icon: <CabinetMenuWelcomeIcon />
            },
          ]
        }} />

        <BlockMenu content={{
          title: 'Обучения',
          icon: <CabinetMenuIconObjects />,
          items: [
            // {
            //   to: "/events",
            //   title: "Мероприятия",
            //   icon: <CabinetMenuEventIcon />
            // },
            {
              to: "/pan-school",
              title: "PAN School",
              icon: <CabinetMenuSchoolIcon />
            },
            {
              to: "/videos",
              title: "Вебинары и обучения",
              icon: <CabinetMenuVebinartIcon />
            },
            {
              to: "/autopanorama",
              title: "Автопанорама",
              icon: <CabinetMenuAutopanoramaIcon />
            },
            {
              to: "/office-training",
              title: "Выездное обучение",
              icon: <CabinetMenuDriveIcon />
            },
          ]
        }} />
        {/*<BlockMenu content={{*/}
        {/*  title: 'Избранное',*/}
        {/*  icon: <CabinetMenuIconFavorites />,*/}
        {/*  items: [*/}
        {/*    {*/}
        {/*      to: "",*/}
        {/*      title: "Объекты",*/}
        {/*      icon: <CabinetFavoritesIconObjects />*/}
        {/*    },*/}
        {/*    {*/}
        {/*      to: "",*/}
        {/*      title: "Комплексы",*/}
        {/*      icon: <CabinetFavoritesIconComplexes />*/}
        {/*    },*/}
        {/*    {*/}
        {/*      to: "",*/}
        {/*      title: "Поселки",*/}
        {/*      icon: <CabinetFavoritesIconCottageSettment />*/}
        {/*    },*/}
        {/*  ]*/}
        {/*}} />*/}
        {/*<BlockMenu content={{*/}
        {/*  title: 'Объекты',*/}
        {/*  icon: <CabinetMenuIconObjects />,*/}
        {/*  items: [*/}
        {/*    {*/}
        {/*      to: "",*/}
        {/*      title: "Вторичка",*/}
        {/*      icon: <CabinetFavoritesIconComplexes />*/}
        {/*    },*/}
        {/*    {*/}
        {/*      to: "",*/}
        {/*      title: "Уступка",*/}
        {/*      icon: <CabinetFavoritesIconComplexes />*/}
        {/*    },*/}
        {/*    {*/}
        {/*      to: "",*/}
        {/*      title: "Загородка",*/}
        {/*      icon: <CabinetObjectsIconHouse />*/}
        {/*    },*/}
        {/*    {*/}
        {/*      to: "",*/}
        {/*      title: "Фиды",*/}
        {/*      icon: <CabinetObjectsIconFeed />*/}
        {/*    },*/}
        {/*  ]*/}
        {/*}} />*/}




      </div>
    </div>

  )
}

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

const mapStateToProps = (state) => ({
  user: state.user.info,
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
